/** * lightbox */
.quick-view-background {
  background-color: rgba(0, 0, 0, 0);
}

/*! PhotoSwipe Default UI CSS by Dmitry Semenov | photoswipe.com | MIT license */
.quick-view-has-mouse .quick-view-button--arrow--left, .quick-view-has-mouse .quick-view-button--arrow--right, .quick-view-ui {
  visibility: visible;
}

.quick-view-minimal--dark .quick-view-top-bar, .quick-view-button {
  background: 0 0;
}

.quick-view, .quick-view-bg, .quick-view-container, .quick-view-navigation, .quick-view-item--placeholder, .quick-view-zoom-wrap {
  -webkit-backface-visibility: hidden;
}

.quick-view-button {
  cursor: pointer;
  opacity: 1;
  -webkit-appearance: none;
  transition: opacity 0.2s;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/*.quick-view {
    overflow: hidden;
}
*/
.quick-view-bg, .quick-view-scroll-wrap, .quick-view-zoom-wrap {
  width: 100%;
  position: absolute;
}

.quick-view-navigation .quick-view-group .quick-view-button-close {
  margin: 0;
}

.quick-view-container, .quick-view-holder, .quick-view-zoom-wrap {
  right: 0;
  bottom: 0;
  top: 0;
  position: absolute;
  left: 0;
}

.quick-view-element--disabled {
  display: none !important;
}

/*! PhotoSwipe main CSS by Dmitry Semenov | photoswipe.com | MIT license */
.quick-view {
  position: fixed;
  display: none;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-text-size-adjust: 100%;
  line-height: initial;
  letter-spacing: initial;
  outline: 0;
}

.quick-view img {
  max-width: none;
}

.quick-view-zoom-disabled .quick-view-item {
  cursor: default !important;
}

.quick-view-animate_opacity {
  opacity: 0.001;
  will-change: opacity;
  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
}

.quick-view-open {
  display: block;
}

.quick-view media-item {
  max-width: unset;
  min-width: unset;
}

.quick-view-zoom-allowed .quick-view-item {
  cursor: -webkit-zoom-in;
  cursor: -moz-zoom-in;
  cursor: zoom-in;
}

.quick-view-zoomed-in .quick-view-item {
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: grab;
}

.quick-view-dragging .quick-view-item {
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: grabbing;
}

.quick-view-bg {
  left: 0;
  top: 0;
  height: 100%;
  opacity: 0;
  transform: translateZ(0);
  will-change: opacity;
}

.quick-view-scroll-wrap {
  left: 0;
  top: 0;
  height: 100%;
  /*overflow: hidden*/
}

.quick-view-container iframe {
  /*background: #212121;
  */
}

.quick-view-container, .quick-view-zoom-wrap {
  -ms-touch-action: none;
  touch-action: none;
}

.quick-view-container, .quick-view-item {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

.quick-view-zoom-wrap {
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
  -webkit-transition: -webkit-transform 222ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: transform 222ms cubic-bezier(0.4, 0, 0.22, 1);
}

.quick-view-bg {
  -webkit-transition: opacity 222ms cubic-bezier(0.4, 0, 0.22, 1);
  transition: opacity 222ms cubic-bezier(0.4, 0, 0.22, 1);
}

.quick-view-animated-in .quick-view-bg, .quick-view-animated-in .quick-view-zoom-wrap {
  -webkit-transition: none;
  transition: none;
}

.quick-view-hide-overflow.quick-view, .quick-view-hide-overflow .quick-view-scroll-wrap {
  overflow: hidden;
}

.quick-view-item {
  position: absolute;
  width: auto;
  height: auto;
  max-width: unset;
  top: 0;
  left: 0;
}

.quick-view-item--placeholder--blank {
  background: #222;
}

.quick-view-ie .quick-view-item {
  width: 100% !important;
  height: auto !important;
  left: 0;
  top: 0;
}

.quick-view-error-msg {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  margin-top: -8px;
  color: #CCC;
}

.quick-view-error-msg a {
  color: #CCC;
  text-decoration: underline;
}

/* Lightbox error message */
.quick-view-error-msg {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

/* prevent iframe from capturing mouse while dragging */
.quick-view.mouse-down .iframe-item {
  pointer-events: none !important;
}

/* Lightbox captions */
.quick-view-caption-positioner {
  position: absolute;
  pointer-events: none;
  inset: 0;
}

.quick-view-caption-wrapper {
  margin: auto;
  position: absolute;
  inset: auto 0 0 0;
}

.quick-view-horizontal-align-left .quick-view-caption-wrapper {
  margin-left: 0;
}

.quick-view-horizontal-align-right .quick-view-caption-wrapper {
  margin-right: 0;
}

.quick-view-horizontal-align-left [data-quick-view-caption] {
  text-align: left;
}

.quick-view-horizontal-align-right [data-quick-view-caption] {
  text-align: right;
}

.quick-view .caption {
  transition: 100ms opacity ease-in-out;
}

.quick-view .caption > * {
  display: inline-block;
}

.quick-view .caption * {
  pointer-events: auto;
  color: inherit;
}

.quick-view .caption.hidden {
  opacity: 0;
}

.quick-view .caption {
  position: absolute;
  margin: 0 auto;
  text-align: center;
}

.editor-overlay-active .quick-view * {
  pointer-events: none;
}

.quick-view .left-arrow, .quick-view .right-arrow, .quick-view .close-button {
  pointer-events: auto;
}

.quick-view .quick-view-bg {
  pointer-events: auto;
}

.quick-view .quick-view-item {
  pointer-events: auto;
}

.editor-overlay-active .quick-view .caption {
  pointer-events: auto;
}

.quick-view .quick-view-placeholder > * {
  background: rgb(239, 238, 236);
  width: 100%;
  height: 100%;
}

.quick-view .quick-view-placeholder svg {
  background: #fff;
}

.quick-view .quick-view-placeholder svg line {
  stroke: rgb(200, 200, 200);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */